<template>
  <div class="navbar">
    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb class="breadcrumb-container" />

    <div class="right-menu">
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img src="data:image/svg+xml;base64,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"
            class="user-avatar">
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <router-link class="inlineBlock" to="/">
            <el-dropdown-item>
              首页
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Cookies from 'js-cookie'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout () {
      Cookies.remove('vue_admin_template_token')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
